<app-page-header title="Calendario" subtitle="Gestión de eventos con Google Calendar" />
<app-calendar />
